import React from 'react'
import Header from '../../components/FormTools/FormHeader'
import { useGetRenewCouponList } from '../../services/hooks'
import { FormattedMessage, useIntl } from 'react-intl';
import { formatMoney } from '../../components/common/utils';
import Status from './Status'
import { ErrorBlock } from 'antd-mobile-v5'
import Loading from '../../components/Loading';

import styles from './RenewCouponsList.module.css'

const RenewCouponsListPage = () => {

  const { data, refresh: refreshList, loading } = useGetRenewCouponList({});
  const { formatMessage } = useIntl()

  if(loading) return <Loading />

  return <>
    <Header
      text={formatMessage({ id: "renew-coupons-list-title" })}
      type={"list"}
    />
    {data.length > 0 ? <div className={styles.couponList}>
      {data.map(coupon => <div className={styles.card + ' ' + (coupon.selected && styles.selected)}>
        <div className={coupon.expired || coupon.used ? styles['tab-disable'] : styles.tab}>{coupon.discount ? <FormattedMessage id="coupon" /> : <FormattedMessage id="coupon-voucher" />}</div>
        <div className={coupon.expired || coupon.used ? styles['content-disable'] : styles.content}>
          <div className={styles.left}>
            <div>{coupon.title}</div>
            <div className={styles.amount}>{formatMoney(coupon.discount, coupon.currencyType)}</div>
          </div>
          <div className={styles.right}>
            <Status coupon={coupon} refreshList={refreshList} />
          </div>
        </div>
        <div className={styles.conditions}>
          <span>{coupon.description}</span>
        </div>
      </div>)}
    </div> : 
    <ErrorBlock 
      status='empty'
      title={formatMessage({ id: 'renew-no-coupons' })}
      description=""
      image={require('../../assets/images/icon/no-coupons.png')} />}
  </>
}

export default RenewCouponsListPage